import { BaseModel, ModelInstance, ToFrontHook, ToBackHook, enumField } from './util';

export enum Country {
  RU = 'RU',
  BL = 'BL',
  AM = 'AM',
  KZ = 'KZ',
  KG = 'KG',
  USA = 'USA',
  GE = 'GE',
  AZ = 'AZ',
  CHN = 'CHN',
  EGY = 'EGY',
  IRN = 'IRN',
  GRC = 'GRC',
  UZB = 'UZB'
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    name_en: 'nameEn',
    country: 'country',
  },
  relation: {
    country: enumField(Country),
  }
})
export class City extends BaseModel {
  id: number;
  name: string;
  nameEn: string;
  country: Country;

  @ToFrontHook
  static toFront(value: any): any {}

  @ToBackHook
  static toBack(value: any): any {}
}
